<div class="app-credit-card" [ngClass]="httpService.theme">
    <div class="section">
        <img src="https://assets.credible.finance/Platinumcard.gif" alt="Credit Card" class="card-img" />
        <div class="description-container">
            <h3 class="heading">Unlock Credit Freedom with Credible Card</h3>

            <div class="description">Join the waitlist for the first AI-powered Credit Builder Card built for Web3
                users.
                Spend using stablecoins, build your on-chain credit score, and transition from overcollateralized to
                no-collateral credit — all while keeping your crypto.
            </div>
            <div class="mt-4 description">Be early. Be Credible. 🚀</div>

            <div class="controls">
                <cf-button [label]="'Join Waitlist'" type="solid" [loading]="loading" [theme]="httpService.theme"
                    (clicked)="preregisterCard()" *ngIf="status === 'not_registered'"></cf-button>
                <cf-button [label]="'You\'re on waitlist'" type="solid" [loading]="loading" [theme]="httpService.theme"
                    *ngIf="status === 'registered'" [disabled]="true"></cf-button>
            </div>
        </div>
    </div>
</div>